module.exports = __webpack_public_path__ + "img/icon_warn.8b1b8978.svg";